import React, { createContext, useContext, useState, useEffect } from 'react';

// Criar contexto
const ThemeContext = createContext();

/**
 * Hook personalizado para usar o contexto de tema
 */
export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme deve ser usado dentro de um ThemeProvider');
  }
  return context;
};

/**
 * Provider do contexto de tema
 */
export const ThemeProvider = ({ children }) => {
  // Verificar se o tema escuro está salvo no localStorage
  const savedTheme = localStorage.getItem('theme');
  const prefersDarkMode = window.matchMedia('(prefers-color-scheme: dark)').matches;
  
  // Definir tema inicial baseado na preferência do usuário ou sistema
  const [isDarkMode, setIsDarkMode] = useState(
    savedTheme ? savedTheme === 'dark' : prefersDarkMode
  );
  
  // Aplicar classe 'dark' ao elemento html quando o tema escuro estiver ativo
  useEffect(() => {
    if (isDarkMode) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
    
    // Salvar preferência no localStorage
    localStorage.setItem('theme', isDarkMode ? 'dark' : 'light');
  }, [isDarkMode]);
  
  // Alternar entre temas claro e escuro
  const toggleTheme = () => {
    setIsDarkMode(prev => !prev);
  };
  
  // Definir tema específico
  const setTheme = (theme) => {
    setIsDarkMode(theme === 'dark');
  };
  
  // Valores fornecidos pelo contexto
  const value = {
    isDarkMode,
    toggleTheme,
    setTheme
  };
  
  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  );
};

export default ThemeContext; 